import React from 'react';
import { companyInfo } from '../styles/variables';

const stats = [
  { num: '2004', label: 'Year Established' },
  { num: 'EU',   label: 'European Markets' },
  { num: 'USA',  label: 'USA Markets' },
  { num: 'CA',   label: 'Canadian Markets' },
  { num: '4+',   label: 'Certifications' },
];

const Intro = () => {
  return (
    <section className="intro-section" id="intro">
      <div className="intro-inner">
        {/* Left: Text */}
        <div className="intro-left">
          <div className="intro-eyebrow">About Swiss N Scott</div>

          <h2 className="intro-title">
            A Legacy of <em>Quality</em>
          </h2>

          <p className="intro-text">
            <strong>Swiss N Scott</strong> is a manufacturer and exporter of premium textile
            products, committed to delivering quality at scale. Our vision is to be a globally
            trusted name in textiles by building strong international partnerships and offering
            sustainable, high-quality solutions.
          </p>

          <p className="intro-text">
            We strive to transform living standards through innovation, continuous research and
            development, and responsible practices — including recycling and efficient resource
            utilization. We specialize in <strong>customized textile products</strong> such as
            flame-retardant fabrics and grey fabric, catering to diverse industry needs.
          </p>

          <p className="intro-text">
            With our own high-capacity production house and a team of skilled professionals, we
            manage the entire process — from dyeing and weaving to carton packing — ensuring
            excellence at every step.
          </p>

          <div className="intro-certs">
            {companyInfo.certifications.map((cert) => (
              <span key={cert} className="intro-cert-badge">{cert}</span>
            ))}
          </div>
        </div>

        {/* Right: Stat Cards — no background */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '0.75rem',
            padding: '2rem',
            background: 'transparent',
            alignContent: 'center',
          }}
        >
          {stats.map((stat, i) => (
            <div
              key={stat.num}
              style={{
                gridColumn: i === 0 ? '1 / -1' : 'auto',
                background: i === 0
                  ? 'linear-gradient(135deg, #2C2416 0%, #3D3020 60%, #4A3820 100%)'
                  : '#ffffff',
                borderRadius: '16px',
                padding: i === 0 ? '2rem 1.5rem' : '1.6rem 1.25rem',
                textAlign: 'center',
                border: i === 0
                  ? '1px solid rgba(184,150,90,0.3)'
                  : '1px solid rgba(184,150,90,0.2)',
                boxShadow: i === 0
                  ? '0 0 32px rgba(184,150,90,0.2), 0 4px 20px rgba(44,36,20,0.2)'
                  : '0 0 20px rgba(184,150,90,0.12), 0 2px 10px rgba(44,36,20,0.07)',
                transition: 'transform 0.25s ease, box-shadow 0.25s ease',
                cursor: 'default',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.boxShadow = i === 0
                  ? '0 0 44px rgba(184,150,90,0.3), 0 8px 28px rgba(44,36,20,0.22)'
                  : '0 0 32px rgba(184,150,90,0.22), 0 6px 18px rgba(44,36,20,0.1)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = i === 0
                  ? '0 0 32px rgba(184,150,90,0.2), 0 4px 20px rgba(44,36,20,0.2)'
                  : '0 0 20px rgba(184,150,90,0.12), 0 2px 10px rgba(44,36,20,0.07)';
              }}
            >
              <div style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: i === 0 ? '3.6rem' : '3rem',
                fontWeight: 700,
                color: i === 0 ? '#dfb06f' : '#2C2416',
                lineHeight: 1,
                marginBottom: '0.5rem',
                letterSpacing: '-0.01em',
              }}>
                {stat.num}
              </div>
              <div style={{
                fontFamily: "'Cinzel', serif",
                fontSize: '0.65rem',
                letterSpacing: '0.18em',
                textTransform: 'uppercase',
                color: i === 0 ? 'rgba(255,255,255,0.6)' : '#4A4A4A',
                fontWeight: 500,
              }}>
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Intro;